"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = redirect;
function redirect(url) {
  var isClient = typeof window !== 'undefined';
  if (!isClient) {
    return;
  }
  window.location.assign(url);
}